<app-dialog-container>
  <div fxLayout="column" fxLayoutGap="24px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h2 mat-dialog-title>Gerar Contrato</h2>

    </div>

    <div mat-dialog-content fxLayout="column" fxLayoutGap="24px">
      <!-- Informações do Cliente/Parceiro -->
      <div class="section-card">
        <div fxLayout="column" fxLayoutGap="16px">
          <h3>Informações do {{ data.entityType === 'customer' ? 'Cliente' :
            'Parceiro' }}</h3>
          <div fxLayout="row wrap" fxLayoutGap="24px grid">
            <div fxFlex="calc(50% - 24px)" fxFlex.lt-md="100">
              <strong>Nome:</strong> {{ data.entity.name }}
            </div>
            <div fxFlex="calc(50% - 24px)" fxFlex.lt-md="100">
              <strong>Documento:</strong> {{ data.entity.document }}
            </div>
            <div fxFlex="calc(50% - 24px)" fxFlex.lt-md="100">
              <strong>Email:</strong> {{ data.entity.email }}
            </div>
            <div fxFlex="calc(50% - 24px)" fxFlex.lt-md="100">
              <strong>Telefone:</strong> {{ data.entity.phone }}
            </div>
          </div>
        </div>
      </div>

      <!-- Seleção do Plano -->
      <div class="section-card">
        <h3>Selecione o Plano</h3>
        <app-plan-selection
          [customerPlans]="plans"
          [selectedPlan]="selectedPlan"
          (planSelected)="onPlanSelect($event)"
          [canEdit]="true"
          (removeContract)="removeExistingContract($event)">
        </app-plan-selection>

        <div *ngIf="selectedPlan" class="template-actions">

          <div *ngIf="isTemplateEdited" class="template-edited-indicator">
            <mat-icon color="accent">check_circle</mat-icon>
            Template personalizado para este contrato
          </div>
        </div>
      </div>

      <!-- Assinaturas -->
      <div class="section-card">
        <div fxLayout="column" fxLayoutGap="16px">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <h3>Assinaturas</h3>
            <button mat-raised-button color="primary" (click)="addSignature()">
              <mat-icon>person_add</mat-icon>
              Adicionar Assinatura
            </button>
          </div>

          <table mat-table [dataSource]="signatures"
            class="signatures-table mat-elevation-z1">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let element"
                [class.primary-contracted]="element.isDefaultContracted">
                {{element.companyName || element.name || element.tradingName}}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let element">{{element.email}}</td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let element">
                <span class="signature-type"
                  [class.contracted-type]="element.isDefaultContracted"
                  [class.contractor-type]="element.isContracted"
                  [class.emitter-type]="element.type === signatureTypes.EMISSOR">
                  {{getSignatureTypeLabel(element.type)}}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="document">
              <th mat-header-cell *matHeaderCellDef>Documento</th>
              <td mat-cell *matCellDef="let element">{{element.document}}</td>
            </ng-container>

            <ng-container matColumnDef="whatsAppNumber">
              <th mat-header-cell *matHeaderCellDef>WhatsApp</th>
              <td mat-cell
                *matCellDef="let element">{{element.whatsAppNumber}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element; let i = index">
                <div fxLayout="row" fxLayoutGap="8px" class="action-buttons">
                  <button mat-icon-button color="primary"
                    (click)="editSignature(element, i)"
                    [disabled]="element.type === signatureTypes.EMISSOR || element.isContracted || element.isDefaultContracted"
                    matTooltip="{{ element.isDefaultContracted ? 'Não é possível editar a contratada' : 
                      element.isContracted ? 'Não é possível editar o contratante principal' : 'Editar assinatura' }}">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn"
                    (click)="removeSignature(i)"
                    [disabled]="element.type === signatureTypes.EMISSOR || element.isContracted || element.isDefaultContracted"
                    matTooltip="{{ element.isDefaultContracted ? 'Não é possível remover a contratada' : 
                      element.isContracted ? 'Não é possível remover o contratante principal' : 'Remover assinatura' }}">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Linha para quando não houver dados -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                <div class="no-data-message">
                  Nenhuma assinatura adicionada
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center"
      fxLayoutGap="8px">
      <div *ngIf="selectedPlan">
        <button mat-stroked-button
          color="primary"
          (click)="openTemplateEditor()"
          [disabled]="loading"
          matTooltip="Editar o template de contrato para este plano">
          <mat-icon *ngIf="!loading">edit</mat-icon>
        </button>
        <button mat-stroked-button
          *ngIf="isTemplateEdited"
          color="warn"
          (click)="resetTemplate()"
          matTooltip="Restaurar o template original">
          <mat-icon>restore</mat-icon>
          Restaurar Original
        </button>
      </div>

      <button mat-raised-button color="primary" (click)="generateContract()"
        [disabled]="!contractForm.valid">
        Gerar Contrato
      </button>

    </div>
  </div>
</app-dialog-container>
